import React from "react";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";
import { AddServiceUserDrawerModal } from "@src/components/organisms/modals/add-service-user-drawer-modal/add-service-user-drawer-modal";

export const AddServiceUserDrawer = () => {
  const showAddServiceUserDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.addServiceUserDrawerModal.showModal,
  );

  return <>{showAddServiceUserDrawerModal && <AddServiceUserDrawerModal />}</>;
};
